// opervex-frontend/src/routes/others.js

import KardexComparison from "../pages/Others/KardexComparison";

const othersRoutes = [
  // Kardex Comparison
  { path: "Others/KardexComparison", private: true, component: <KardexComparison />, role: "KARDEX_COMPARISON" },
];

export default othersRoutes;
